module.exports = __webpack_public_path__ + "static/img/order_active.babdcdbc.png";